import { render, staticRenderFns } from "./Linkage.vue?vue&type=template&id=80bdf524&scoped=true&"
import script from "./Linkage.vue?vue&type=script&lang=js&"
export * from "./Linkage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bdf524",
  null
  
)

export default component.exports